// Generated by ReScript, PLEASE EDIT WITH CARE
'use client'

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Config$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as PnMHelper$PorterinFeature from "../domain/helper/PnMHelper.mjs";
import * as PnMStoreEn$PorterinFeature from "../domain/store/PnMStoreEn.mjs";
import * as CommonHelper$PorterinFeature from "../../../shared/core/helpers/CommonHelper.mjs";
import * as AuthContextV1$PorterinFeature from "../../login/view-model/contexts/auth-context/AuthContextV1.mjs";
import * as PnMFormHelper$PorterinFeature from "../domain/helper/PnMFormHelper.mjs";
import * as LeadFormDatePickerCmp$PorterinFeature from "../../../shared/lead-flow/view/LeadFormDatePickerCmp.mjs";
import * as LeadFormSubmitButtonCmp$PorterinFeature from "../../../shared/lead-flow/view/LeadFormSubmitButtonCmp.mjs";
import * as PnMHouseSizeDropdownCmp$PorterinFeature from "./components/form/PnMHouseSizeDropdownCmp.mjs";
import * as PnmHouseSizeSelectorProps$PorterinFeature from "../domain/types/PnmHouseSizeSelectorProps.mjs";
import * as AutocompleteDropdownStyles$PorterinFeature from "../../../shared/auto-complete/view/styles/AutocompleteDropdownStyles.mjs";
import * as VehicleFareEstimateInputCmp$PorterinFeature from "../../../shared/lead-flow/view/component/VehicleFareEstimateInputCmp.mjs";
import * as GoogleReactAutocompleteCmpMod$PorterinFeature from "../../../shared/auto-complete/view/components/GoogleReactAutocompleteCmpMod.mjs";

function PnMFareEstimateFormFieldsCmp(Props) {
  var form = Props.form;
  var styles = Props.styles;
  var input_field_styles = Props.input_field_styles;
  var response = Props.response;
  var show_house_size = Props.show_house_size;
  var country = Props.country;
  var match = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var pickupLocationHandler = function (addressValue, postalAddress) {
    Curry._2(form.updatePickup, (function (input, value) {
            return {
                    pickup: {
                      landmark: value.landmark,
                      location: value.location,
                      extended_address: {
                        state: postalAddress.state,
                        city: postalAddress.city,
                        pincode: postalAddress.pincode,
                        locality: postalAddress.locality,
                        sub_locality: postalAddress.sub_locality
                      }
                    },
                    drop: input.drop,
                    date: input.date,
                    name: input.name,
                    mobile: input.mobile,
                    house: input.house,
                    show_house_field: input.show_house_field
                  };
          }), {
          landmark: addressValue.landmark,
          location: addressValue.location,
          extended_address: {
            state: postalAddress.state,
            city: postalAddress.city,
            pincode: postalAddress.pincode,
            locality: postalAddress.locality,
            sub_locality: postalAddress.sub_locality
          }
        });
  };
  var dropLocationHandler = function (addressValue, postalAddress) {
    Curry._2(form.updateDrop, (function (input, value) {
            return {
                    pickup: input.pickup,
                    drop: {
                      landmark: value.landmark,
                      location: value.location,
                      extended_address: {
                        state: postalAddress.state,
                        city: postalAddress.city,
                        pincode: postalAddress.pincode,
                        locality: postalAddress.locality,
                        sub_locality: postalAddress.sub_locality
                      }
                    },
                    date: input.date,
                    name: input.name,
                    mobile: input.mobile,
                    house: input.house,
                    show_house_field: input.show_house_field
                  };
          }), {
          landmark: addressValue.landmark,
          location: addressValue.location,
          extended_address: {
            state: postalAddress.state,
            city: postalAddress.city,
            pincode: postalAddress.pincode,
            locality: postalAddress.locality,
            sub_locality: postalAddress.sub_locality
          }
        });
  };
  var getFormErrorMessage = function (param) {
    var match = Curry._1(form.dirty, undefined);
    if (response !== undefined && !(response.TAG === /* Ok */0 || match)) {
      return response._0;
    } else {
      return "";
    }
  };
  return React.createElement("form", {
              className: styles["fare-estimate-form"],
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement(VehicleFareEstimateInputCmp$PorterinFeature.make, {
                  label: PnMStoreEn$PorterinFeature.pickup_location_label,
                  is_required: true,
                  children: JsBindings$PorterinUtils.isBrowser(undefined) ? React.createElement(GoogleReactAutocompleteCmpMod$PorterinFeature.make, {
                          id: "pickup-location-" + String(Math.random()) + "",
                          value: form.input.pickup.landmark,
                          api_key: Config$PorterinUtils.google_maps_api_key,
                          form_on_change: pickupLocationHandler,
                          placeholder: PnMStoreEn$PorterinFeature.pickup_location_placeholder,
                          response_type: /* PlaceAutocomplete */0,
                          wrapperStyle: AutocompleteDropdownStyles$PorterinFeature.wrapperStyle,
                          menuStyle: AutocompleteDropdownStyles$PorterinFeature.menuStyle,
                          inputClass: "" + styles["pickup-input"] + " " + (
                            form.submitting ? styles.disabled : ""
                          ) + "",
                          itemClass: styles["dropdown-item"]
                        }) : null,
                  error: CommonHelper$PorterinFeature.getError(form.pickupResult),
                  styles: input_field_styles
                }), React.createElement("div", {
                  className: styles.divider
                }), React.createElement(VehicleFareEstimateInputCmp$PorterinFeature.make, {
                  label: PnMStoreEn$PorterinFeature.drop_location_label,
                  is_required: true,
                  children: JsBindings$PorterinUtils.isBrowser(undefined) ? React.createElement(GoogleReactAutocompleteCmpMod$PorterinFeature.make, {
                          id: "drop-location-" + String(Math.random()) + "",
                          value: form.input.drop.landmark,
                          api_key: Config$PorterinUtils.google_maps_api_key,
                          form_on_change: dropLocationHandler,
                          placeholder: PnMStoreEn$PorterinFeature.drop_location_placeholder,
                          response_type: /* PlaceAutocomplete */0,
                          wrapperStyle: AutocompleteDropdownStyles$PorterinFeature.wrapperStyle,
                          menuStyle: AutocompleteDropdownStyles$PorterinFeature.menuStyle,
                          inputClass: "" + styles["drop-input"] + " " + (
                            form.submitting ? styles.disabled : ""
                          ) + "",
                          itemClass: styles["dropdown-item"]
                        }) : null,
                  error: CommonHelper$PorterinFeature.getError(form.dropResult),
                  styles: input_field_styles
                }), match.is_authenticated ? null : React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: styles.divider
                      }), React.createElement(VehicleFareEstimateInputCmp$PorterinFeature.make, {
                        label: PnMStoreEn$PorterinFeature.phone_number_label,
                        is_required: true,
                        children: React.createElement("input", {
                              className: styles["mobile-input"],
                              disabled: form.submitting,
                              placeholder: PnMStoreEn$PorterinFeature.phone_number_placeholder,
                              type: "tel",
                              value: form.input.mobile,
                              onBlur: (function (param) {
                                  Curry._1(form.blurMobile, undefined);
                                }),
                              onChange: (function ($$event) {
                                  Curry._2(form.updateMobile, (function (input, value) {
                                          return {
                                                  pickup: input.pickup,
                                                  drop: input.drop,
                                                  date: input.date,
                                                  name: input.name,
                                                  mobile: value,
                                                  house: input.house,
                                                  show_house_field: input.show_house_field
                                                };
                                        }), $$event.target.value);
                                })
                            }),
                        error: CommonHelper$PorterinFeature.getError(form.mobileResult),
                        styles: input_field_styles
                      })), React.createElement("div", {
                  className: styles.divider
                }), React.createElement(VehicleFareEstimateInputCmp$PorterinFeature.make, {
                  label: PnMStoreEn$PorterinFeature.shifting_date_label,
                  is_required: true,
                  children: React.createElement(LeadFormDatePickerCmp$PorterinFeature.make, {
                        form: form,
                        country: country
                      }),
                  error: CommonHelper$PorterinFeature.getError(form.dateResult),
                  styles: input_field_styles
                }), React.createElement("div", {
                  className: styles.divider
                }), show_house_size ? React.createElement(VehicleFareEstimateInputCmp$PorterinFeature.make, {
                    label: PnMStoreEn$PorterinFeature.house_size_label,
                    is_required: true,
                    children: React.createElement(PnMHouseSizeDropdownCmp$PorterinFeature.make, {
                          props: PnmHouseSizeSelectorProps$PorterinFeature.makeProps(PnMFormHelper$PorterinFeature.getHouseSizeOptions(undefined), (function (value) {
                                  PnMFormHelper$PorterinFeature.updateHouseSize(value, form);
                                }), Belt_Option.map(form.input.house, PnMFormHelper$PorterinFeature.displayHouseSize), styles["dropdown-list-wrapper"], Caml_option.some(undefined))
                        }),
                    error: CommonHelper$PorterinFeature.getError(form.houseResult),
                    styles: input_field_styles
                  }) : null, React.createElement(LeadFormSubmitButtonCmp$PorterinFeature.make, {
                  is_disabled: form.submitting,
                  event_name: PnMStoreEn$PorterinFeature.pnm_ga_submit_event,
                  cta: PnMHelper$PorterinFeature.getSubmitButtonCta(country),
                  error: getFormErrorMessage(undefined)
                }));
}

var make = PnMFareEstimateFormFieldsCmp;

export {
  make ,
}
/* react Not a pure module */
